import { Icon } from 'components/Icons/Types'

const GhostIcon = ({ width = 103, height = 140, className = undefined, color = '#777' }: Icon) =>
  <svg width={ width } height={ height } viewBox='0 0 103 140' className={ className } fill='transparent'>
    <path d='M6 34.8818C6 -3.80291 97 -3.45119 97 34.8818V125L85.5642 115.153L74.1283 125L62.4492 115.153L50.2834 125L38.1176 115.153L26.4385 125L16.2193 115.153L6 125V34.8818Z' stroke={ color } strokeWidth='12' />
    <circle cx='32.1441' cy='60.7452' r='11.3698' stroke={ color } strokeWidth='9' />
    <circle cx='70.1801' cy='60.7452' r='11.3698' stroke={ color } strokeWidth='9' />
    <line x1='49.1357' y1='89.9197' x2='52.5319' y2='89.9197' stroke={ color } strokeWidth='10' strokeLinecap='round' />
  </svg>

export default GhostIcon
